export default "__VITE_PUBLIC_ASSET__b514b4a6__"